import { UPDATE_SELECTED_TAB } from "../actionTypes";

export const updateTab = data => {
  return {
    type: UPDATE_SELECTED_TAB,
    tabValue: data.tabValue
  };
};